import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { Collection } from '@/components/icons/collection';
import { Filter } from '@/components/icons/filter';
import { Tab } from '@/components/ui/tab';

export function Tabs() {
  const intl = useIntl();
  const location = useLocation();

  const pathParts = location.pathname.split('/');
  const activeTab = pathParts[pathParts.length - 1];

  return (
    <div className="flex items-center gap-2">
      <Tab
        Icon={Collection}
        title={intl.formatMessage({
          defaultMessage: 'Channels',
          description:
            'Opening sub-tab: list paid sourcing channels and campaigns',
        })}
        to="channels"
        isActive={activeTab === 'channels'}
        preserveSearch
      />
      <Tab
        Icon={Filter}
        title={intl.formatMessage({
          defaultMessage: 'Funnel',
          description: 'Opening sub-tab: applicant funnel and stage conversion',
        })}
        to="funnel"
        isActive={activeTab === 'funnel'}
        preserveSearch
      />
    </div>
  );
}
